import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";

import {
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  Fab,
  Divider,
  TextField,
  Typography,
  Avatar,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import UploadIcon from "@mui/icons-material/Upload";
import PrintIcon from "@mui/icons-material/Print";
import SaveIcon from "@mui/icons-material/Save";
import DeleteIcon from "@mui/icons-material/Delete";

import { ResultTable } from "..";
import MainSectionContainer from "../../../subComponents/MainSectionContainer";
import { Box } from "@mui/system";
import { uploadReportData, uploadResult } from "../../../firebase/functions";
import { LoadingButton } from "@mui/lab";

import logo from "../../../assets/media/logo.jpg";

const UploadResult = () => {
  const [loading, setLoading] = useState(false);
  const [pupil, setPupil] = useState({
    name: "",
    className: "",
    pupilID: "",
    result: [],
    reportData: {},
  });

  const [display, setDisplay] = useState(false);

  const [subjectData, setSubjectData] = useState([]);

  useEffect(() => {
    setSubjectData((prev) => pupil["result1-2"] || []);
  }, [pupil]);

  return (
    <div style={{ height: "100%" }}>
      <MainSectionContainer>
        <Grid spacing={2} container direction="column">
          <Grid item>
            <SelectPupil pupil={pupil} setPupil={setPupil} />
          </Grid>
          <Grid item>
            <ResultTable
              subjectData={subjectData}
              setSubjectData={setSubjectData}
            />
          </Grid>
        </Grid>
      </MainSectionContainer>
      <Box
        sx={{
          position: "fixed",
          right: "50%",
          bottom: 15,
        }}>
        <Fab
          size="medium"
          color="primary"
          onClick={() => {
            setDisplay(true);
          }}>
          <PrintIcon />
        </Fab>
      </Box>
      <Box
        sx={{
          position: "fixed",
          right: "0%",
          bottom: 15,
          "& > *": {
            marginRight: "12px !important",
          },
        }}>
        <Box
          sx={{
            mr: 16,
            display: "inline-block",
          }}>
          <Fab
            size="medium"
            color="primary"
            onClick={() => {
              setSubjectData((prev) => prev.slice(0, prev.length - 1));
            }}>
            <DeleteIcon />
          </Fab>
        </Box>
        <Fab
          variant="extended"
          size="medium"
          color="primary"
          aria-label="add"
          style={{
            fontWeight: "bold",
          }}
          onClick={() => {
            setSubjectData((prev) => [
              ...prev,
              {
                id: prev.length + 1,
                subject: "",
                catest12: 0,
                catest34: 0,
                exam: 0,
                total: 0,
                grade: "",
                highestScore: 0,
                lowestScore: 0,
              },
            ]);
          }}>
          <AddIcon sx={{ mr: 1 }} />
          Subject
        </Fab>
        <LoadingButton
          type="submit"
          variant="contained"
          loadingPosition="start"
          loading={loading}
          size="medium"
          color="primary"
          aria-label="upload"
          style={{
            fontWeight: "bold",
            borderRadius: 20,
          }}
          onClick={() => {
            setLoading(true);
            uploadResult(subjectData, pupil.id)
              .then(() => setLoading(false))
              .catch((error) => setLoading(false));
          }}>
          {!loading ? (
            <UploadIcon sx={{ mr: 1 }} />
          ) : (
            <span style={{ display: "block", padding: "0px 16px" }} />
          )}
          Upload
        </LoadingButton>
      </Box>

      {display && (
        <PrintPage
          pupil={pupil}
          subjectData={subjectData}
          setSubjectData={setSubjectData}
        />
      )}
    </div>
  );
};

export default UploadResult;

const SelectPupil = ({ setPupil, pupil }) => {
  const { data: pupilsData } = useSelector((state) => state.staff.pupils);
  const handleChange = (event) => {
    const pupil = event.target.value;
    setPupil(pupil);
  };
  return (
    <FormControl fullWidth>
      <InputLabel id="demo-simple-select-label">Pupils</InputLabel>
      <Select
        labelId="demo-simple-select-label"
        id="demo-simple-select"
        variant="standard"
        value={pupil || ""}
        label="Pupils"
        onChange={handleChange}>
        {pupilsData.map((pupilData) => (
          <MenuItem value={pupilData}>{pupilData.name}</MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};
const PrintPage = ({ subjectData, setSubjectData, pupil }) => {
  const { data: pupilsData } = useSelector((state) => state.staff.pupils);
  const [reportData, setReportData] = useState({
    opened: 0,
    term: "",
    attendance: "",
    highestScore: 0,
    lowestScore: 0,
    ...pupil["reportData1-2"],
    name: pupil.name,
    className: pupil.className,
    noInClass: pupilsData.length,
    average: (() => {
      let cTotal = 0,
        cAvg = 0;
      subjectData.forEach((data) => {
        cTotal += data.total;
      });
      cAvg = cTotal / subjectData.length;

      return `${cAvg.toFixed(2)}%`;
    })(),
    cTotal: (() => {
      let cTotal = 0;
      subjectData.forEach((data) => {
        cTotal += data.total;
      });
      return cTotal;
    })(),
  });

  const [savedData, setSavedData] = useState(false);

  const setDatavalue = (which) => (value) => {
    setReportData((prev) => ({
      ...prev,
      [which]: value,
    }));

    setSavedData(false);
  };
  return (
    <div
      style={{
        width: "100%",
        height: "100%",
        position: "fixed",
        overflowY: "auto",
        top: 0,
        left: 0,
        zIndex: 1200,
        backgroundColor: "#fff",
      }}>
      <Grid container style={{ height: "100%" }} spacing={1}>
        <Grid
          item
          xs={12}
          container
          justifyContent="center"
          style={{ margin: "16px 0px" }}>
          <Grid container item alignItems="center" justifyContent="center">
            <Grid item>
              <Avatar style={{ height: 100, width: 100 }} src={logo} />
            </Grid>
            <Grid item>
              <Typography
                variant="h4"
                style={{ fontWeight: "bold", paddingLeft: 16 }}>
                Paul Omachi Memorial Schools
              </Typography>
            </Grid>
          </Grid>
          <Grid item>
            <Typography
              variant="h5"
              color="primary"
              style={{ fontWeight: "bold" }}>
              Motto:: Raising Excellent Achievers
            </Typography>
          </Grid>
        </Grid>

        <div style={{ width: "100%", padding: "0px 12px" }}>
          <Divider
            style={{
              width: "100%",
            }}
          />
        </div>

        <Grid item xs={12} container>
          <StaffInputData
            row={6}
            text="Name Of Pupil "
            textValue={reportData["name"]}
          />
          <StaffInputData
            row={6}
            text="Name Of Class "
            textValue={reportData["className"]}
          />
          <StaffInputData
            row={6}
            text="Times School Opened "
            textValue={reportData["opened"]}
            setTextValue={setDatavalue("opened")}
          />
          <StaffInputData
            row={6}
            text="Term for 20 "
            textValue={reportData["term"]}
            setTextValue={setDatavalue("term")}
          />
          <StaffInputData
            row={6}
            text="No Of. Attendance "
            textValue={reportData["attendance"]}
            setTextValue={setDatavalue("attendance")}
          />
          <StaffInputData
            row={6}
            text="Total No In Class "
            textValue={reportData["noInClass"]}
          />
        </Grid>
        <Grid item xs={12} style={{ width: "100%", margin: "0px 8px" }}>
          <ResultTable
            subjectData={subjectData}
            setSubjectData={setSubjectData}
          />
        </Grid>

        <Grid
          item
          xs={12}
          container
          style={{
            paddingBottom: 64,
          }}>
          <StaffInputData
            row={6}
            text="Cummulative Total "
            textValue={reportData["cTotal"]}
          />
          <StaffInputData
            row={6}
            text="Overall Average "
            textValue={reportData["average"]}
          />
        </Grid>
      </Grid>
      {!savedData && (
        <Box
          sx={{
            position: "fixed",
            right: "5%",
            bottom: 15,
          }}>
          <Fab
            size="medium"
            color="primary"
            onClick={() => {
              uploadReportData(reportData, pupil.id).then(() => {
                setSavedData(true);
              });
            }}>
            <SaveIcon />
          </Fab>
        </Box>
      )}
    </div>
  );
};

const StaffInputData = ({ row, text, type, textValue, setTextValue }) => {
  return (
    <Grid
      container
      item
      alignItems="flex-end"
      xs={row}
      spacing={2}
      style={{
        padding: "2px 8px",
      }}>
      <Grid item>
        <Typography variant="body2">{text}</Typography>
      </Grid>
      <Grid item xs>
        <TextField
          hiddenLabel
          fullWidth
          type={type ? type : "text"}
          value={textValue}
          onChange={(e) => {
            if (setTextValue) setTextValue(e.target.value);
          }}
          size="small"
          sx={{
            "& .MuiFilledInput-input": {
              textTransform: "capitalize",
            },
          }}
          style={{
            fontSize: 12,
          }}
          variant="filled"
        />
      </Grid>
    </Grid>
  );
};
